<button
  class="refresh-button__button"
  data-testid="button"
  procure-button
  variant="stroked"
  [disabled]="disabled"
  [loading]="isLoading"
  (click)="refresh.emit()"
>
  <mat-icon> refresh </mat-icon>
</button>
